export const zoomInstructions = ({ isDesktop }) => ({
  position: "absolute",
  textAlign: "center",
  top: isDesktop ? "25px" : "20px",
  color: "grey7",
  zIndex: 100000000,
});

export const productImagesContainer = () => ({
  //* DEV NOTE:  marginTop to allow for header in UIVersion 2

  overflow: "hidden",
  flexGrow: 1,
  flexShrink: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "0",
  position: "relative",

  ".react-transform-wrapper, .react-transform-component": {
    height: "100%",
    width: "100%",
    zIndex: "10",
  },
});

export const imageGridContainerWrapper = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
};

export const gridContainer =
  ({
    UIVersion,
    numberOfItems,
    isReviewOrderPage,
    doubleWidthColumnOverride = false,
  }) =>
  ({ isDesktop, isTablet, isMobile }) => ({
    height: "100%",
    width: "100%",
    maxWidth: isDesktop ? "1200px" : "800px",
    position: "absolute",

    padding: isReviewOrderPage
      ? "32px"
      : UIVersion === 2
      ? !isDesktop
        ? "16vh"
        : "9vh"
      : "80px",
    px: isReviewOrderPage
      ? // * Review page
        "0px"
      : UIVersion === 2
      ? isDesktop
        ? // * Product, V2, Desktop
          "75px"
        : isTablet
        ? // * Product, V2, Tablet
          "52px"
        : // * Product, V2, Mobile
          "10px"
      : 0,

    display: "grid",
    gridTemplateColumns:
      (!isMobile && numberOfItems === 3) || doubleWidthColumnOverride
        ? "2fr 1fr"
        : "1fr 1fr",
    gridTemplateRows: isMobile && numberOfItems === 3 ? "15fr 9fr" : "1fr 1fr",

    //DEV NOTE: Places the equipment items in the right number of containers
    // based on how many there products there are
    gridTemplateAreas:
      numberOfItems === 3
        ? !isMobile
          ? // * 3 - Desktop
            `"image-group-0 image-group-1"
   "image-group-0 image-group-2"`
          : //  * 3 - Mobile/Tablet
            `"image-group-0 image-group-0"
   "image-group-1 image-group-2"`
        : numberOfItems === 2 && !isMobile
        ? // * 2 - Desktop/Tablet
          `"image-group-0 image-group-1"
   "image-group-0 image-group-1 "`
        : numberOfItems === 2
        ? // * 2 - Mobile
          `"image-group-0 image-group-0"
        "image-group-1 image-group-1 "`
        : // * 1 - All
          `"image-group-0 image-group-0"
   "image-group-0 image-group-0"`,

    // -----THIS IS A BREAKDOWN OF ABOVE BUT EASIER TO READ------

    //  For when only 2 products are to be customised
    // (FOR DESKTOP/TABLET)  gridTemplateAreas: `"image-group-0 image-group-0"
    //  "image-group-1 image-group-1 "`,

    // OR

    // (FOR MOBILE) gridTemplateAreas:`"image-group-0 image-group-1"
    // "image-group-0 image-group-1 "`

    //   //  For when only 1 product is to be customised
    //   gridTemplateAreas: `"image-group-0 image-group-0"
    //   "image-group-0 image-group-0"`,

    // -------------------------END-----------------------------

    ".imageGroup--0": {
      gridArea: "image-group-0",
      //TODO: REMOVE LATER
      // backgroundColor: "pink",
    },
    ".imageGroup--1": {
      gridArea: "image-group-1",
      //TODO: REMOVE LATER
      // backgroundColor: "lightgreen",
    },
    ".imageGroup--2": {
      gridArea: "image-group-2",
      //TODO: REMOVE LATER
      // backgroundColor: "lightblue",
    },
  });

export const individualImageContainer = ({ _UIVersion }) => ({
  position: "relative",

  "> div": {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50% 50%",
    backgroundSize: "contain",
    // backgroundSize: "auto 100%",
  },
});

export const controls = {
  position: "absolute",
  left: "40px",
  bottom: "76px",
  zIndex: 100,
};

export const imageBadgesContainer = {
  position: "absolute",
  top: "80px",
  right: "40px",
  zIndex: 200,
};

export const imageBadgesInTransform = (badgePosition) => ({
  position: "absolute",
  top: "78%",
  ...badgePosition,
});
